
<script>

  import func from "../../libs/functions.js";
  //import { StripeCheckout } from 'vue-stripe'

  import {
    mapGetters,
    mapState,
    mapActions
  } from "vuex";
  
  import _ from "lodash";

  import _system from '../../libs/system';

   import VueSlider from 'vue-slider-component'
   import 'vue-slider-component/theme/default.css'

   import iziToast from 'izitoast'
   import 'izitoast/dist/css/iziToast.min.css';

   const StripeCheckout = window.StripeCheckout;

   window.plans = [];

   export default {
   name: "Pricing",
   components: {
    VueSlider
  },
   data() {
      return {
         handler: {},
         purchases: [],
         allPurchases: [],
         total: {},
         StripeCheckout:StripeCheckout,
         loading: {
            open: false
         },
         pricingInterval: 'year',
         socialChannelPrice: 7,
         teamMemberPrice: 15,
         teamMemberCount: 1,
         socialChannelCount: 1,
         upgraded: false,
         couponCode: '',
         couponPercentage: 0,
         couponObject: {}
      }
   },
   computed: {
   ...mapGetters('workspaces', ['workspaces', 'currentWorkspace']),
   ...mapGetters('workspaceusers', ['workspaceusers']),
   ...mapGetters('accounts', ['accounts']),
   ...mapGetters('session', ['isLoggedIn', 'getUser']),
   ...mapGetters('tags', ['tags', 'tagsByName', 'tagsById']),
   ...mapGetters('workspaces', ['workspaces', 'currentWorkspace']),
   ...mapGetters('subscriptions', ['getSubscriptions']),
   ...mapState('plans', ['plans']),
      getBasePlans(){
         return this.plans.filter(obj => /base/.test(obj.id));
      },
      totalLimits(){
         this.total.price = this.amountCutter(_.sumBy(this.allPurchases, 'amount'));
         this.total.users = _.sumBy(this.allPurchases, 'userLimit');
         this.total.channels = _.sumBy(this.allPurchases, 'channelLimit');

         return this.total
      }
   },
   methods: {
   ...mapActions("session", ["setUser"]),
   ...mapActions("htmlModals", ["setPricingModal"]),
   ...mapActions('tags', ['setTags']),
   ...mapActions('workspaces', ['setWorkspaces', 'pushWorkspace', 'setCurrentWorkspace']),
   ...mapActions('workspaceusers', ['setWorkspaceusers']),
   ...mapActions("loading", ["setLoadingApp", "setLoadingAppReRender"]),
      amountCutter(amount){
         if(amount.toString().length > 3){
            return amount.toString().slice(0, amount.toString().length -2)
         }else{
            return amount
         }
         
      },
      closeModal(){
         document.body.classList.remove('overflowYHidden');
         this.setPricingModal(false);
      }
   },
   mounted(){
      document.body.addEventListener('keyup', e => { if (e.keyCode === 27) { this.setPricingModal(false) } })
      document.body.classList.add('overflowYHidden');

   },
   created(){

      this.allPurchases = _(this.workspaceusers).filter( wsuser => (wsuser.user.payments && wsuser.user.payments.length)).map('user.payments').flatten().value()

      this.allPurchases = this.allPurchases.concat(this.getSubscriptions)

      this.allPurchases = _.map(this.allPurchases, (p) => {
         
         p.amount = parseInt(this.amountCutter(p.amount))
         return p
      })


   }
}

</script>

<template>


<div class="modalWrapper">
<div  @click=" closeModal()" class="modal"> </div>
   <div class="ui grid">
      <div style="margin-top: 50px; margin-bottom: 0px; z-index:9999999;" class="thirteen wide column centered">
         <div style="background: #f9f9f9; border-radius: 7px;" class="ui stackable grid shadow">
            <div style="background: #ffffff; padding: 15px 0px; border-radius: 10px;" class="row">


               <div  v-if="(!upgraded && purchases.length) || allPurchases.length" class="sixteen wide column centered">
                  <div class="ui basic segment">
                       <h1 style="font-size: 36px; color: #444; font-weight: 300; color: #727272;">Your Purchases</h1>
                        <table class="ui very basic structured table" >
                             <thead>
                              <tr>
                                 <th>Plan Name</th>
                                 <th>Price</th>
                                 <th>Channels</th>
                                 <th>Users</th>
                                 <th>Status</th>
                              </tr>
                           </thead>
                        <tbody>

                           <tr v-show="allPurchases.length" v-for="purchase in allPurchases" :key="purchase._id">
                              <td style="width: 100%;" class="pa3 bb br b--light-gray"> 
                                    <span  style="display: block;" class="b db">{{purchase.package}} </span>
                                 
                    
                              </td>
                              <td>
                                 
                                    <span v-if="purchase.amount">${{amountCutter(purchase.amount)}}</span>
                                    <span v-if="!purchase.amount" >$0</span>
                               
                              </td>
                              <td>
                                 
                              <span>{{purchase.channelLimit}}</span>
                               
                              </td>
                              <td>
                                
                                 <span>{{ (purchase.userLimit > 99) ? 'Unlimited' : purchase.userLimit }}</span>
                            
                              </td>
                              <td>
                                 <div class="ui green small basic button disabled">Active</div>
                              </td>
                           </tr>
<!--                            <tr v-show="purchase.status == 'succeeded'" v-for="purchase in purchases" :key="purchase.id">
                              <td style="width: 100%;" class="pa3 bb br b--light-gray"> 
                                    <span style="display: block; font-weight: bold;" class="b db">{{purchase.metadata.planName}} - ${{purchase.amount.toString().slice(0, purchase.amount.toString().length -2 )}}</span>
                              </td>
                              <td class="pa3 bb b--light-gray center-aligned">
                                 <div v-if="(isCurrentWorkspacePurchased(purchase))" class="ui fluid gray button disabled" @click="activatePurchase(purchase)">Refunded</div>
                                 <div v-if="(!isCurrentWorkspacePurchased(purchase))" class="ui fluid green button disabled" @click="activatePurchase(purchase)">Automatically Activated</div>
                              </td>
                           </tr> -->
                        </tbody>
                          <tfoot>
                           <tr class="positive">
                           <th><b>Total</b></th>
                           <th> <b>${{totalLimits.price}}</b></th>
                           <th> <b>{{totalLimits.channels}}</b></th>
                           <th> <b>{{ (totalLimits.users > 99) ? 'Unlimited' : totalLimits.users }}</b></th>
                           <th></th>
                        </tr>
                        </tfoot>
                     </table>
                   </div>
               </div>



<!--                <div class="twelve wide column centered">


                  <div v-if="getUser.email != 'david@kano.me'" data-aos="fade" data-aos-duration="1500" class="ui basic segment center aligned">
                     <h1 style="font-size: 36px; color: #444; font-weight: 300; color: #727272;">PAY AS YOU GO</h1>
                  </div>
                  <div style="border-bottom: 1px solid #eee;" v-if="getUser.email == 'david@kano.me' && currentWorkspace.plan == 'Free'" data-aos="fade" data-aos-duration="1500" class="ui basic segment center aligned">
                                    <img class="ui image centered small circular" :src="'https://pbs.twimg.com/profile_images/452117645131653120/2rt6YJIb.png'" alt="">
                     <h1 style="font-size: 36px; color: #444; font-weight: 300; color: #727272;">Exclusive <b>60% Discount</b> Only For Kano</h1>
                     <div v-if="!couponPercentage" class="ui action huge input fluid">
                        <input v-model="couponCode" v-on:keyup.enter="tryCoupon()" type="text" placeholder="Type your 60% Coupon Code!">
                        <button @click="tryCoupon()" class="ui button">APPLY DISCOUNT CODE</button>
                     </div>
                  </div>
                  <div class="ui grid">
                     <div class="row">
                        <div style="text-align: right; padding-right: 2rem;" class="sixteen wide column">
   
                              <span v-if="pricingInterval == 'year'" style="font-style: italic; padding: 10px; display: inline-block; color: #666;"> <span v-if="!couponPercentage">Save 25% Yearly</span> <b style="font-size:16px;" v-if="couponPercentage"> 25% + {{couponPercentage}}% = {{couponPercentage + 25}}% Discount Applied 🤩</b> </span>
                              <span v-if="pricingInterval == 'month'" style="font-style: italic; padding: 10px; display: inline-block; color: #666;"> Monthly </span>
                              <div style="padding-bottom: 2px; vertical-align: middle;" class="ui fitted toggle checkbox check">
                                 <input @click="(pricingInterval == 'year') ? pricingInterval = 'month' : pricingInterval = 'year' " type="checkbox" :checked="(pricingInterval == 'year') ? true : false">
                                    <label></label>
                              </div>

                        </div>
                        <div v-for="plan in getPlansByInterval(pricingInterval)" :key="plan.id" :style="(plan.nickname == 'Business') ? 'border-left:1px solid #eee;':''" class="eight wide column centered"> 
                           <div class="ui horizontal segments" style="border:none;box-shadow: none;">
                              <div style="color: #444; border:none;" class="ui segment">
                                 <p :style="(plan.nickname == 'Business') ? 'color:#474FFF;':'color:#CB4F4A;'" style="margin-bottom:5px; font-size: 22px; font-weight:bold;">{{plan.nickname}}</p>
                                <div class="ui small label" style="background: #f1f1f1;">
                                   {{teamMemberCount}} User
                                   </div>
                                <div class="ui small label" style="background: #f1f1f1;">
                                    {{socialChannelCount}} Channel
                                   </div>
                              </div>
                              <div style="color: #444; border:none;" class="ui segment">
                                 <p style=" font-size:56px; line-height: 1; text-align:right;"> <span style="font-size: 22px; display:inline-block; vertical-align: super;">$</span>
                                 {{(plan.discount) ? calculatePlanPrice(plan.discount.price, couponPercentage, plan) : calculatePlanPrice(plan.price, couponPercentage, plan)}}
                                 <span style="font-size: 14px;">/mo</span></p>
                              </div>
                           </div>
                           <div style="padding-top:0;" class="ui basic large segment pricingList">

                           <ul v-if="plan.nickname != 'Business'" :style="{color: (plan.nickname == 'Business')? '#fbfbfb':'#444444' }" class="list">
                              <li class="mb1"><i class="check icon"></i>Up to 3 Channels</li>
                              <li class="mb1"><i class="check icon"></i> 1 User</li>
                              <li class="mb1"><i class="check icon"></i> 1 Month History</li>
                              <li class="mb1"><i class="minus icon"></i> Collaboration</li>
                              <li class="mb1"><i class="check icon"></i> All Core Features</li>
                          </ul>

                          <ul v-if="plan.nickname == 'Business'" :style="{color: (plan.nickname == 'Business')? '#444444':'#444444' }" class="list">
                           <li class="mb1"><i class="check icon"></i> Up to 10 Channels</li>
                           <li class="mb1"><i class="check icon"></i> Up to 5 Users</li>
                           <li class="mb1"><i class="check icon"></i> 12 Month History</li>
                           <li class="mb1"><i class="check icon"></i> Collaboration</li>
                           <li class="mb1"><i class="check icon"></i> All Core Features</li>
                       </ul>


                         <button v-if="currentWorkspace.plan == plan.nickname" :class="{ disabled: loading.open }" class="ui fluid button" disabled>Already in use</button>
                        <button :style="(plan.nickname == 'Business') ? 'background:#474FFF;':'background:#CB4F4A;'"  style="color: #fbfbfb;" v-if="currentWorkspace.plan != plan.nickname" @click="open(plan)" :class="{ disabled: loading.open  || plan.nickname != 'Business' && socialChannelCount > 3 || plan.nickname != 'Business' && teamMemberCount > 1 }" class="ui fluid button">Choose Plan</button>
                             
                           </div>
                        </div>                     
                     </div>


                     <div v-if="onlyActiveAccounts().length > 10 || workspaceusers.length > 5" style="margin-top:20px;"  class="row">
                        <div class="sixteen wide column center aligned">
                           <div class="ui warning message">
                           <div class="header">
                              Your number of channels <span :style="(onlyActiveAccounts().length > 10) ? 'color:#ff0000;':''">[{{onlyActiveAccounts().length}}]</span> or teammembers <span :style="(workspaceusers.length > 5) ? 'color:#ff0000;':''">[{{workspaceusers.length}}]</span>  are not suitable for standard pricing plans.
                           </div>
                              Please <a href="to:sales@juphy.com">contact us</a> to get custom Enterprise or Discounted Agency pricing.
                           </div>
                        </div>
                     </div>
                     <div style="margin-top:20px;"  class="row">
                        <div class="sixteen wide column center aligned">
                                    <p style=" font-weight: 400; font-size: 22px; margin-top: 0;">
                                          Estimate your spend
                                    </p>
                        </div>
                     </div>
                     <div style="border-top: 1px solid #eee;" class="row">
                              <div style="padding: 15px 0px; border-bottom: 1px solid #eee;" class="sixteen wide column">
                                 <div class="ui grid">
                                    <div class="four wide column"> 
                                       <p style="font-size: 16px; color: #858585; margin-bottom: 5px;">
                                          Each additional social channel is <b> ${{socialChannelPrice}}/month </b>
                                          <span v-if="couponPercentage">🤩</span>
                                       </p>
                                    </div>
                                    <div class="twelve wide column">         
                                       <p style="margin-bottom: 6px; color: #858585;">
                                          <strong style="color: #858585;">{{socialChannelCount}}</strong> Social channel
                                       </p>      
                                       <vue-slider v-model="socialChannelCount" :min="1" :max="10" :tooltip="'never'" :tooltip-placement="'bottom'"></vue-slider>
                                    </div>
                                 </div>
                              </div>
                        </div>
                     <div class="row">
                              <div style="padding: 0px;" class="sixteen wide column">
                                 <div class="ui grid">
                                    <div class="four wide column"> 
                                       <p style="font-size: 16px; color: #858585; margin-bottom: 5px;">
                                          Each additional team member is <b>${{teamMemberPrice}}/month</b>
                                          <span v-if="couponPercentage">🤩</span>
                                       </p>
                                    </div>
                                    <div class="twelve wide column">         
                                       <p style="margin-bottom: 6px; color: #858585;">
                                          <strong style="color: #858585;">{{teamMemberCount}}</strong> Team member
                                       </p>      
                                       <vue-slider v-model="teamMemberCount" :min="1" :max="5" :tooltip="'never'" :tooltip-placement="'bottom'"></vue-slider>
                                    </div>
                                 </div>
                              </div>
                        </div>

  
        
                  </div>
               </div> -->
            </div>
         </div>
      </div>
   </div>
</div>


</template>


<style scoped>

      .pricingList ul li{
         list-style: none;
         margin-bottom: 5px;
      }

      .pricingList ul{
         padding-left: 0.5rem;
      }

      /deep/ .ui.toggle.checkbox input:checked ~ .box::after, .ui.toggle.checkbox input:checked ~ label::after {
         left: 2.20rem;
         -webkit-box-shadow: none;
         box-shadow: none;
         width: 12.5px;
         height: 12.5px;
         top: 4.5px;
         background-color: #fff !important;
      }

      /deep/ .ui.toggle.checkbox input ~ .box::after, .ui.toggle.checkbox input ~ label::after {
         left: .5rem;
         -webkit-box-shadow: none;
         box-shadow: none;
         width: 12.5px;
         height: 12.5px;
         top: 4.5px;
      }

      /deep/ .ui.toggle.checkbox .box::before, .ui.toggle.checkbox label::before {
         background: rgba(53, 50, 50, 0.15);
      }

      .ui.toggle.checkbox input:checked ~ .box::before, .ui.toggle.checkbox input:checked ~ label::before {
         background-color: #ddd !important;
      }

      /deep/ .vue-slider-process {
         background: #4b6cb7;
         background: -webkit-linear-gradient(to left, #182848, #4b6cb7);
         background: linear-gradient(to left, #182848, #4b6cb7);
         border-radius: 15px;
      }

      /deep/  .vue-slider.vue-slider-ltr{
            height: 8px !important;
         }
      /deep/   .vue-slider.vue-slider-ltr:hover{
            cursor: pointer;
         }

      /deep/ .vue-slider-dot{
         width: 16px !important;
         height: 16px !important;
      }

      .specialList .item .content{
         padding: 10px 0px;
         text-align: center;
         color: #666666;
      }


      .pricingTitle {
         font-size: 28px;
         font-weight: bold;
         margin-bottom: 40px;
         display: block;
         color: #2D333A;
      }

      .price{
         font-size: 46px;
         display: block;
         color: #2D333A;
         font-weight: bold;
      }

      .pricingButton.active{
         border-radius: 20px !important;
         background: #CB4F4A !important;
         color: #fbfbfb;
         transition: 0;
      }

      .pricingButton.active:hover{
         color: #fbfbfb !important;
      }

      .priceAlt{
         font-size: 12px;
         display: block;
      }

      .pricingList{
         margin-top: 20px;
         color: #636363;
      }

      .modalWrapper {
         position: fixed; 
         top: 0; 
         right: 0; 
         bottom: 0; 
         left:0; 
         z-index: 9999; 
         overflow-y: scroll;
         overflow-x: hidden;
      }
      .modal {
         position: fixed; 
         top: 0; 
         right: 0; 
         bottom: 0; 
         left:0; 
         background: rgba(15, 17, 26, 0.35) none repeat scroll 0% 0%; 
         z-index: 9999; 
         overflow-y: scroll;
         overflow-x: hidden;
      }

      .shadow{
         box-shadow: 0px 0px 44px rgba(0, 0, 0, 0.45);
         border: none;
      }

      .parametric {
         display: inline-block;
         width: 50px;
         border: 1px dashed #ddd;
         color: #888;
         font-size: 30px;
         vertical-align: middle;
         padding-top: 5px;
         border-radius: 5px;
         text-align: center;
      }
</style>





// WEBPACK FOOTER //
// src/components/dashboard/Pricing.vue